import * as React from 'react';
import localeService from 'src/dataServices/LocaleService';
import './NotFoundPage.scss';

interface INotFoundPageProps {
  locale?: string;
}

const NotFoundPage: React.FC<INotFoundPageProps> = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-text">
        404 - {localeService.getText("NotFoundPage", "NotFound") || "Not Found"}
      </div>
    </div>
  );
};

export default NotFoundPage;
